// DO NOT EDIT -- generated from fs/services/orgs/model.proto

import * as flags from '../../shared/flags';
import * as protobuf from '../../../google/protobuf';

export interface OrgID {
  orgId: string;
}

export interface UmbrellaID {
  umbrellaId: string;
}

export interface OrgOrUmbrellaID {
  orgId?: string;
  umbrellaId?: string;
}

export namespace OrgOrUmbrellaID {
  export enum id {
    orgId = 1,
    umbrellaId = 2
  }

  export function id_oneof(m: OrgOrUmbrellaID): { opt: id.orgId, val: string } | { opt: id.umbrellaId, val: string } | null {
    if (m.orgId != null) { return { opt: id.orgId, val: m.orgId } }
    if (m.umbrellaId != null) { return { opt: id.umbrellaId, val: m.umbrellaId } }
    return null;
  }
}

export interface SeatID {
  /**
   * The org or umbrella that "owns" this seat. The same email
   * address could be associated with both an org as well as that
   * org's umbrella, in which case the other seat details apply
   * only to one context or the other. This field is used to
   * distinguish which context applies.
   */
  owner: OrgOrUmbrellaID | null;
  email: string;
}

export interface Org {
  /** The id of the org; unique for all orgs. */
  orgId: string;
  /** Friendly display name (e.g. "fruitshoppe"). */
  name: string;
  /** The time at which the org was created by our system. */
  created: protobuf.timestamp | null;
  /**
   * The email address that performed the sign-up flow that
   * resulted in this org's creation.
   */
  creator: string;
  /** Defined by the user. Represents the size of the organization on the company level, not the number of seats for the org. */
  size: number;
  /** Defined by the user. */
  industry: string;
  /** Primary domain provided by the user. */
  domain: string;
  /** Whether org has opted out of benchmarking */
  benchmarkingDisabled: boolean;
  /** Provided by the user */
  country: string;
  /** Intended platform(s) provided by the user during signup */
  platform: Platform;
  /**
   * The umbrella that controls this org's plan. Blank if there is
   * no associated umbrella.
   */
  umbrellaId: string;
  /** The plan details for this org, including session/seat allocation */
  plan: PlanConfig | null;
  prevPlan: PlanConfig | null;
  /** Information about payment and subscription. */
  subscriptionDetails: SubscriptionDetails | null;
  /** Information about this org's quota cycle and to-date usage. */
  quotaDetails: QuotaDetails | null;
  scheduled: ScheduledOperationConfig | null;
  prevScheduled: ScheduledOperationConfig | null;
  /** When (and whether!) a teammate was invited */
  firstInvitationDate: protobuf.timestamp | null;
  /**
   * Deprecated: use auth_config instead
   * 
   * @deprecated
   */
  idProvider: string;
  /**
   * Deprecated: use auth_config instead
   * 
   * @deprecated
   */
  idProviderEnforced: boolean;
  /**
   * Deprecated: use auth_config instead
   * 
   * @deprecated
   */
  auth0TeamName: string;
  /** Parameters that control how seats in this org authenticate themselves. */
  authConfig: AuthConfig | null;
  /**
   * The search clusters into which this org's data is indexed. Must
   * contain exactly one or two elements. If it contains two elements,
   * the first is considered primary: it is the cluster to which queries
   * are directed (and writes are sent to both).
   */
  searchClusters: string[];
  searchClusterLastMod: protobuf.timestamp | null;
  /** Indicates if View-Only access to share links is enabled */
  shareSessionEnabled: boolean;
  /** Email domains allowed for session sharing */
  shareEmailDomains: string[];
  /** Indicates if request-to-join org is enabled or disabled. */
  joinOrgEnabled: boolean;
  /**
   * Email domains allowed for join org requests (if enabled).
   * If list is empty (and enabled), will allow all domains.
   */
  joinOrgEmailDomains: string[];
  /** Flags for the org, merged with default, Umbrella, and plan flags */
  flags: flags.FlagsProto | null;
  /** Flag overrides for the org (does not include plan or pack flags) */
  unmergedFlags: flags.FlagsProto | null;
  /** The first time a session was recorded */
  firstRecordDate: protobuf.timestamp | null;
  /**
   * Deprecated: please use ingestion-settings instead
   * 
   * @deprecated
   */
  recordingShutoff: boolean;
  /**
   * Deprecated: please use ingestion-settings instead
   * 
   * @deprecated
   */
  privacyHash: string;
  /**
   * Map of integration unique IDs to integration definitions
   * 
   * @deprecated
   */
  integrations: { [key: string]: Integration };
  /** Number of minutes between each data export; the default value 0 means 1 day or 1440 minutes */
  exportFreqMinutes: number;
  /** Dates that various emails were sent */
  emailStatus: EmailStatus | null;
  /** The time when this org was marked as deleted. */
  tombstone: protobuf.timestamp | null;
  /** True if the org is in the process of being nuked. */
  nuking: boolean;
  /**
   * Deprecated. Use fieldmeta instead.
   * 
   * @deprecated
   */
  hiddenCustomVars: string[];
  orgLevel0: OrgLevel0 | null;
  exportFreqMinutesDefaulted: boolean;
  userInactivityTimeout: number;
  adminInactivityTimeout: number;
  coupons: Coupon[];
  /**
   * When set, no new seats of any kind will be created. This is so that, if necessary, we can
   * guarantee that no users can access an org until we allow them to again. Specifically, this
   * will block creating invites, accepting invites, logging in as a guest, and autoprovisioning
   * via SSO.
   */
  createSeatsDisabled: boolean;
  /**
   * Enable/Disable system-generated nightly emails
   * Don't send any org-state related emails to users
   */
  orgStateEmailsDisabled: boolean;
  /** Don't send any digest emails to users */
  digestEmailsDisabled: boolean;
  overageConfig: SessionOverageConfig | null;
  notificationConfig: NotificationConfig | null;
  seatRequestConfig: CustomSeatRequestConfig | null;
  defaultLocale: string;
}

/** Persisted completion state of in-app onboarding Getting Started pane */
export enum SetupStage {
  /** The zero or default state. */
  STAGE_UNSET = 0,
  /** Initial setup has been confirmed and is no longer the default app tab. */
  CONFIRMED = 1,
  /** Initial setup has been dismissed and disappears from the app. */
  DISMISSED = 2
}

export interface OrgLevel0 {
  completedOnboardingVersion: number;
  newFreemium: boolean;
  acceptedTermsVersion: number;
  setupStage: SetupStage;
  completedPrivacyOnboarding: boolean;
}

export interface Umbrella {
  /** The id of the umbrella; unique for all umbrellas. */
  umbrellaId: string;
  /** User-defined name of the umbrella. */
  name: string;
  created: protobuf.timestamp | null;
  /** Orgs which are part of the Umbrella. Must be at least one. */
  orgs: Org[];
  /** Specifies total sessions and seat allocation across orgs */
  plan: PlanConfig | null;
  /** Information about payment and subscription. */
  subscriptionDetails: SubscriptionDetails | null;
  /** Current managers */
  managers: Seat[];
  /** Sessions not allocated to an org */
  freeSessions: protobuf.int64;
  /** The sum of all detatched orgs sessions during a quota cycle */
  detachedOrgSessions: protobuf.int64;
  /**
   * Quota fields
   * TODO(sarahgrace): Use QuotaDetails instead
   */
  quotaCycleStart: protobuf.timestamp | null;
  quotaCycleEnd: protobuf.timestamp | null;
  scheduled: ScheduledOperationConfig | null;
  prevScheduled: ScheduledOperationConfig | null;
  /** Only populated if include_org_invites in the request was true */
  orgInvites: AttachOrgInvite[];
  /** Flags for the umbrella, with default and plan flags merged in. */
  flags: flags.FlagsProto | null;
  /** Flag overrides for the umbrella (does not include plan or pack flags) */
  unmergedFlags: flags.FlagsProto | null;
  coupons: Coupon[];
  overageConfig: SessionOverageConfig | null;
  defaultLocale: string;
}

/** Base for new plans */
export enum BasePlan {
  /** Not valid but can indicate "unchanged" when updating. */
  UNSET_PLAN = 0,
  /** The old "pro" plan config */
  PRO_PLAN = 1,
  FREEMIUM_PLAN = 2,
  /** The new free plan to replace freemium */
  FREE_PLAN = 8,
  BUSINESS_PLAN = 3,
  ENTERPRISE_PLAN = 4,
  BASIC_PLAN = 5,
  /** For Embed only orgs */
  EMBED_PLAN = 6,
  ADVANCED_PLAN = 7,
  DATA_PLAN = 9
}

/** Plan stage for new plans */
export enum PlanStage {
  /** Not valid but can indicate "unchanged" when updating. */
  UNSET_STAGE = 0,
  TRIAL_STAGE = 1,
  EXPIRED_TRIAL_STAGE = 2,
  ACTIVE_STAGE = 3,
  CANCELLED_STAGE = 4,
  DELETED_STAGE = 5
}

/** Represents an org's configured plan. Values must all be set even if not being changed. */
export interface PlanConfig {
  sessions: protobuf.int64;
  seats: number;
  /** retention window */
  history: number;
  alerts: number | null;
  quotaLength: QuotaPeriod;
  /**
   * Represents the last time plans changes were made which restarted the quota cycle.
   * Current quota cycle is calculated from this date.
   */
  anchor: protobuf.timestamp | null;
  price: number;
  interval: Interval;
  /** The list of add-on packs included with the plan */
  packs: Pack[];
  /** We are moving from packs towards base plans */
  basePlan: BasePlan;
  /** Stage is being replaced by PlanStage */
  planStage: PlanStage;
  /** The trial expiration date. Ignored if the stage is not TRIAL or EXPIRED_TRIAL. */
  trialExpiration: protobuf.timestamp | null;
  /** Only set for new plans which are no longer pack-based. Used to be represented by trial expiration. */
  cancellation: protobuf.timestamp | null;
  invoiced: boolean;
  salesMananger: SalesManager | null;
  notes: string;
  /** analytics retention window */
  analyticsHistory: number;
  /** The unit of measurement to evaluate the retention period */
  retentionPeriodUnit: RetentionPeriodUnit;
  /**
   * Determines the percentage of sessions that are "sampled" for FSTA.
   * For example, value of 20 (20%) sample rate will translate to a 80% drop rate within ingestion-settings.
   * Valid values: 0-99, defaults to 0.
   */
  splitProcessingSampleRate: number;
  /**
   * This setting is only relevant for free / trial orgs. When set, the only thing it does is
   * allow admins in FSTA to add or edit payment into in the app. This is false by default,
   * meaning that by default free & trial orgs cannot add a payent card.
   */
  allowAddPaymentInfo: boolean;
  serverEvents: protobuf.int64;
  changeLog: ChangeLogEntry[];
}

export enum RetentionPeriodUnit {
  /** If an org has a RetentionPeriodUnit of NO_UNIT, we will default to treating the retention value as MONTHS. */
  NO_UNIT = 0,
  MONTHS = 1,
  DAYS = 2
}

export interface ChangeLogEntry {
  timestamp: protobuf.timestamp | null;
  message: string;
  changedBy: string;
}

export interface ScheduledOperationConfig {
  cancellation: protobuf.timestamp | null;
  priceChange: ScheduledOperationConfig.PriceChange | null;
}

export namespace ScheduledOperationConfig {
  export interface PriceChange {
    changeDate: protobuf.timestamp | null;
    price: number | null;
  }
}

/** SessionOverageConfig represents an org/umbrella's settings for managing session overages. */
export interface SessionOverageConfig {
  blockLimit: number;
  overageAllowed: boolean;
  lastDetectedOverageBlockConsumed: protobuf.timestamp | null;
}

/** NotificationConfig represents an org-level notification settings. */
export interface NotificationConfig {
  /** If true then no quota related emails are sent to org users */
  quotaEmailsDisabled: boolean;
  /** Decimal value - 0 < x < 1 (if 0 then will default to a fallback value) */
  nearQuotaEmailThreshold: number;
  /** If true, then the org will not be alerted when data capture has been paused */
  dataCaptureStoppedDisabled: boolean;
}

export interface CustomSeatRequestConfig {
  /** whether or not custom seat requests are currently enabled */
  enabled: boolean;
  /** optional text */
  customSeatText: string;
  /** required url if custom seats are enabled */
  customSeatUrl: string;
}

export interface SalesManager {
  name: string;
}

export interface CardInfo {
  lastFour: string;
  cardType: string;
  expMonth: number;
  expYear: number;
  name: string;
}

export interface AttachOrgInvite {
  umbrellaId: string;
  orgId: string;
  invitee: string;
  invitedBy: string;
  created: protobuf.timestamp | null;
}

/** The times that various org status emails were sent. */
export interface EmailStatus {
  deletionWarningSent: protobuf.timestamp | null;
  installSnippetEmailSent: protobuf.timestamp | null;
  trialExpiredEmailSent: protobuf.timestamp | null;
  overQuotaWarningSent: protobuf.timestamp | null;
  nearQuotaWarningSent: protobuf.timestamp | null;
  firstSessionEmailSent: protobuf.timestamp | null;
}

export interface Integration {
  /** service id */
  serviceId: string;
  /** can be set to false to turn off an integration w/out losing config */
  enabled: boolean;
  authToken: string;
  config: { [key: string]: string };
  /** unique ID of integration within the Org */
  id: string;
}

export interface SubscriptionDetails {
  /** Stripe customer ID. Optionally set if payment info is set */
  customerId: string;
  /** Standard stripe subscription ID */
  subId: string;
  /** Old stripe plan ID, only check if sub ID not set */
  planId: string;
  /** How many times a credit card charge has failed. Resets on successful charge or card update. */
  chargeFailures: number;
  /** How many times a credit card has failed to charge for session overages. Resets on successful charge. */
  overageChargeFailures: number;
  invoiceName: string;
  invoiceInfo: string;
}

export interface QuotaDetails {
  quotaCycleStart: protobuf.timestamp | null;
  quotaCycleEnd: protobuf.timestamp | null;
  /** Fraction of users (0.0 to 1.0) that we will drop due to ramping up traffic. */
  trafficFiltering: number;
}

export interface OrgState {
  isOverQuota: boolean;
  isAlmostOverQuota: boolean;
  /** percentage of sessions used to sessions purchased */
  percentSessionsUsed: number;
  /** capture is paused when the session quota is reached and all allowed overage blocks are consumed */
  captureIsPaused: boolean;
}

export interface AuthConfig {
  idProvider: string;
  idProviderEnforced: boolean;
  auth0TeamName: string;
  /** optional datastore ID for the corresponding auth provider configuration */
  idProviderIntId: protobuf.int64;
  /** whether the org only allows password logins from verified devices (GAuth/SSO always allowed) */
  requiresDeviceVerification: boolean;
  ssoAutoProvisionEnabled: boolean;
  ssoCustomSignOutEnabled: boolean;
  ssoRoleMapping: boolean;
  scimProvisioningEnabled: boolean;
}

export enum Role {
  UNKNOWN = 0,
  ADMIN = 1,
  USER = 2,
  VIEW_ONLY = 3,
  UMBRELLA_MANAGER = 4,
  ARCHITECT = 5,
  EXPLORER = 6
}

export enum EmbedRole {
  EMBED_ROLE_UNKNOWN = 0,
  EMBED_ROLE_ADMIN = 1
}

export interface EmbedPartner {
  embedPartnerId: string;
  embedPartnerName: string;
  creatorEmail: string;
  orgIds: string[];
}

export enum Pack {
  /** No pack for the 0 value, this is considered a "default" value. */
  PACK_INVALID = 0,
  DATA = 2,
  SUPPORT = 3,
  PAGE_INSIGHTS = 4,
  DEVTOOLS = 5,
  ALERTS = 6,
  CONVERSIONS = 7,
  ADDITIONAL_ROLES = 10,
  NATIVE_MOBILE = 11,
  SELF_SERVICE_SSO = 12,
  DATA_LAYER_OBSERVER = 13,
  JOURNEYS = 14,
  WAREHOUSING = 15,
  SESSION_MANAGEMENT = 17,
  RETENTION = 18,
  METRIC_INSIGHTS = 19,
  DQM = 20,
  SPACES = 21,
  DASHBOARDS = 22,
  WEBHOOKS = 23,
  GO_LIVE = 24,
  CONFIGURABLE_FORM_PRIVACY = 25,
  CLIENT_SIDE_RAGEHOOKS = 26,
  CONVERSION_MAPS = 27,
  UNLIMITED_SEATS = 28,
  FSTA = 29,
  EXPLORER_ROLE = 30,
  SPLIT_PROCESSING = 31,
  WATCHED_ELEMENTS = 32,
  VISIT_API = 33,
  WAYFINDER = 34,
  SUGGESTED_ELEMENTS = 35,
  ATTRIBUTE_SUGGESTIONS = 36,
  SESSION_SUMMARIES = 37,
  OPPORTUNITIES = 38
}

export enum Interval {
  /**
   * Should match options in stripe/plan.go
   * No payment is being made
   */
  NONE = 0,
  DAY = 1,
  WEEK = 2,
  MONTH = 3,
  YEAR = 4,
  QUARTER = 5,
  /** twice per year */
  SEMI_ANNUAL = 6
}

export enum QuotaPeriod {
  QUOTA_UNSET = 0,
  QUOTA_MONTHLY = 1,
  QUOTA_ANNUAL = 2,
  QUOTA_SEMIANNUAL = 3
}

export interface Seat {
  id: SeatID | null;
  role: Role;
  created: protobuf.timestamp | null;
  invitedBy: string;
  /**
   * If true, the email domain is managed by Google and thus is capable
   * of using Google auth.
   */
  googleManaged: boolean;
  /**
   * Flags for the seat, including any permission flags implied
   * by the seat's role. Check `merged_flags` (must request via `merge_flags in request)
   * to get the complete set of permissions for the seat.
   */
  flags: flags.FlagsProto | null;
  /** Seat flags merged with the org flags. Must be specifically requested. */
  mergedFlags: flags.FlagsProto | null;
  /**
   * The last time this seat was actively using FullStory. This value is updated in lockstep with the user's login
   * record's last activity e.g. every time the user's session is revalidated.
   * This value is only populated for callers that have `PermViewSeatLastActivity`, o/w it is left unset.
   */
  lastActivity: protobuf.timestamp | null;
  /** Tracks if the seat has been disabled. If true, the user will not be able to log into this org. */
  disabled: boolean;
  /**
   * First and Last name can be stored on the seat. If not present, the first and last name stored on the Person
   * object can be used.
   */
  firstName: string;
  lastName: string;
  isScimManaged: boolean;
}

export interface Coupon {
  id: string;
  appliedBy: string;
  startDate: protobuf.timestamp | null;
  endDate: protobuf.timestamp | null;
}

/** Invoice for stripe payment */
export interface Invoice {
  /** ID of the invoice itself */
  id: string;
  /** ID of the subscription the invoice is for; empty if its a one-off invoice */
  subId: string;
  date: protobuf.timestamp | null;
  start: protobuf.timestamp | null;
  end: protobuf.timestamp | null;
  attempted: boolean;
  paid: boolean;
  amountDue: number;
  total: number;
  cardType: string;
  lastFour: string;
  lines: Invoice.InvoiceLine[];
}

/** Invoice for stripe payment */
export namespace Invoice {
  export interface InvoiceLine {
    description: string;
    amount: number;
  }
}

export interface Invite {
  id: SeatID | null;
  role: Role;
  created: protobuf.timestamp | null;
  invitedBy: string;
  /** First and Last name only set if requested. Can be unset. */
  firstName: string;
  lastName: string;
}

export interface UmbrellaInvite {
  /** Should have umbrella id */
  id: SeatID | null;
  created: protobuf.timestamp | null;
  invitedBy: string;
  orgInvites?: UmbrellaInvite.OrgInvites | null;
  umbrellaManager?: boolean;
  /** First and Last name only set if requested. Can be unset. */
  firstName: string;
  lastName: string;
}

export namespace UmbrellaInvite {
  export interface OrgInvites {
    invites: UmbrellaInvite.OrgInvite[];
  }

  export interface OrgInvite {
    orgId: string;
    role: Role;
  }

  export enum invite {
    orgInvites = 4,
    umbrellaManager = 5
  }

  export function invite_oneof(m: UmbrellaInvite): { opt: invite.orgInvites, val: UmbrellaInvite.OrgInvites } | { opt: invite.umbrellaManager, val: boolean } | null {
    if (m.orgInvites != null) { return { opt: invite.orgInvites, val: m.orgInvites } }
    if (m.umbrellaManager != null) { return { opt: invite.umbrellaManager, val: m.umbrellaManager } }
    return null;
  }
}

export enum AppearanceMode {
  APPEARANCE_MODE_UNSET = 0,
  APPEARANCE_MODE_SYSTEM = 1,
  APPEARANCE_MODE_LIGHT = 2,
  APPEARANCE_MODE_DARK = 3
}

export interface Person {
  email: string;
  created: protobuf.timestamp | null;
  firstName: string;
  lastName: string;
  /** The orgs the Person has a Seat in */
  orgIds: string[];
  /** Useful for creating and validating cookies */
  resetCount: number;
  /** The roles that the user selected on sign up */
  personas: string[];
  /** Determines whether or not the user should be shown extra help in the search UI */
  searchTipsHidden: boolean;
  /** The last org the person logged in to */
  lastOrg: string;
  /**
   * Orgs that the person currently has access to. Only included if explicitly requested with `GetPersonRequest.FetchOrgs`.
   * OrgIds will always be returned in the `org_ids` field if the full Org is not needed.
   * TODO(jh): need a way to also include provisional orgs
   */
  orgs: Org[];
  /** True if the person has set a password. */
  hasSetPassword: boolean;
  /** A set of fields that describes what the user has seen and completed regarding on-boarding. */
  level0: PersonLevel0 | null;
  /** Users appearance mode preference */
  appearanceMode: AppearanceMode;
  /** The primary reason for using FS the user selected on sign up */
  reason: string;
}

export interface PersonLevel0 {
  sawShare: boolean;
  sawSearch: boolean;
  sawRageAndDeadClicks: boolean;
  sawInspectMode: boolean;
  sawSearchies: boolean;
  sawProDialogInTrial: number[];
  /** Gave feedback or hid the feedback bar */
  gaveSearchV2Feedback: boolean;
  /** Saw the full Activity Maps splash screen. */
  sawActivityMaps: boolean;
  /** Saw the second/last notification that FS3 is being decommissioned. */
  sawFs3Warning2: boolean;
  /** The list of orgIds for which the user completed the wizard onboarding flow. */
  completedOnboarding: OnboardingCompletion[];
  /** Update modal for adding features to the Freemium plan. */
  sawFreemiumUpdate: boolean;
}

/** An org for which a Person completed onboarding. */
export interface OnboardingCompletion {
  orgId: string;
  /** The latest version they completed (usually same for all orgs) */
  version: number;
}

export enum Platform {
  UNSET_PLATFORM = 0,
  WEB = 1,
  WEB_AND_MOBILE = 2
}
